import { createSlice } from "@reduxjs/toolkit";

const initialMsaState = {
  result: null,
  url: null,
  reportParserUrl: null,
  listLoading: false,
  actionsLoading: false,
  reportActionLoading: false,
  reportStatus: null,
  reportParserStatus: null,
  reportParserTaskId: null,
  taskId: null,
  message: {
    error: null,
    success: null,
    modalSuccess: null,
    modalError: null,
  },
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const msaSlice = createSlice({
  name: "msa",
  initialState: initialMsaState,
  reducers: {
    catchError: (state, action) => {
      let error =
        action.payload.error.response && action.payload.error.response.data ? action.payload.error.response.data.errors : action.payload.error.message;
      if (error.constructor.name === "Object") {
        let temp = [];
        for (let [k, v] of Object.entries(error)) {
          temp.push(`${k}->${v}`);
        }
        error = temp;
      }
      state.message.error = error;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    startReportCall: (state, action) => {
      state.reportActionLoading = true;
    },

    fileParsed: (state, action) => {
      const { id, status } = action.payload;
      state.actionsLoading = false;
      state.error = null;
      state.reportParserStatus = status;
      // state.result = entity;
      // state.message.success = message;
    },
    reportGenerated: (state, action) => {
      const { id, status } = action.payload;
      state.reportActionLoading = false;
      state.error = null;
      state.taskId = id;
      state.reportStatus = status;
    },

    updateStatus: (state, action) => {
      const { status, url } = action.payload;
      state.reportStatus = status;
      state.url = url;
    },

    updateParserStatus: (state, action) => {
      const { status, url } = action.payload;
      state.reportParserStatus = status;
      state.reportParserUrl = url;
    },

    clearParseResult: (state, action) => {
      state.result = null;
    },
    clearMsaReportDownloadUrl: (state, action) => {
      state.url = null;
    },

    //update message
    updateMessage: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      const { type, message } = action.payload;
      switch (type) {
        case "error":
          state.message.error = message;
          break;
        case "success":
          state.message.success = message;
          break;
        case "modalSuccess":
          state.message.modalSuccess = message;
          break;
        case "modalError":
          state.message.modalError = message;
          break;
      }
    },
  },
});
